import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import services from 'core/services';

import { Component, Serialize, Loading } from 'core/components';
import { Icon, Card, CardContent, CardFooter, Button, Stepper, Link, Preloader } from 'core/components/Framework7';
import { addToCart, changeCountItem, deleteItem } from 'content/pages/Cart/Module';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import classes from './styles.module.css';

const Price = Serialize.Price;

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      item: this.initialValue,
      currentValue: props.item.product ? this.handleProductInCart(props.item.product.id) : 0,
      latestValue: props.item.product ? this.handleProductInCart(props.item.product.id) : 0,
    }

    // console.log("constroctor", this.state.item);

    this.debouncedHandleStepper = debounce(this.handleChangeStepper, 500);

    this.stepperElm = React.createRef()
  }

  get initialValue() {
    return this.parseProductItem()
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseProductItem() {
    const { item, env } = this.props;
    const noPhoto = env && env.layout.assets.images.noPhoto;
    // console.log(item)

    return {
      id: item.id,
      alt: item.product ? item.product.cover ? item.product.cover.title : null : null,
      url: item.product && item.product.cover && services.utils.url.image(item.product.cover, 3) || noPhoto,
      title: item.product ? item.product.name : null,
      link: item.id,
      childrenType: item.childrenType,
      currentPrice: item.product ? item.product.currentPrice : null,
      currentDiscount: item.product ? item.product.currentDiscount : 0,
      consumerPrice: item.product ? item.product.consumerPrice : null,
      productCount: item.product ? this.handleProductInCart(item.product.id) : 0,
      productId: item.product ? item.product.id : null,
      quantity: item.product ? item.product.quantity : 0,
      unitType: item.product ? item.product?.unitType : null,
      limitBuyQuantity: item.product ? item.product?.limitBuyQuantity : 0
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevItem = prevState.item
    const currItem = this.initialValue

    // console.log('prevItem:', prevItem, ', currItem:', currItem)

    if (prevItem.productCount != currItem.productCount)
      this.handleCurrentValue()
  }

  changeStepper(value) {
    if (this.state.currentValue == value) return

    // console.log('changeStepper set to Current Value=> ', 'value:', value)

    this.setState({
      currentValue: value,
    }, () => {
      this.debouncedHandleStepper();
    })
  }

  //بخش ارسال مقادیر داخل استپر به سمت سرور
  handleChangeStepper() {
    const { cart } = this.props;
    const { item, currentValue } = this.state;
    const { minimumValue } = item?.unitType || {};
    // console.log("minimumValue in productItem", minimumValue);


    this.setState({ loading: true })

    const params = {
      store: 2,
      errorHandler: true
    }

    const model = {
      count: currentValue,
      orderId: null,
      productId: item.productId
    }

    const cartId = services.utils.product.cartItemId(cart, item.productId)
    const cartItemExists = cartId != null

    // console.log('product id:', item.productId, ' - cart id:', cartId, ' - cart item exists:', cartItemExists, 'minimumValue ', minimumValue, "model send", model);
    // console.log('handleChangeStepper => stepperElm current:', this.stepperElm.current)

    // item exists in cart
    if (cartItemExists) {
      // delete from cart when item count set to 0
      if (currentValue < minimumValue) {
        return this.deleteItem(cartId)
      } else {
        // change cart item count
        return this.props.changeCountItem(cartId, { count: currentValue }, params)
          .then(r => { this.handleCurrentValue() })
          .catch(this.handleAPICatch)
          .finally(r => { this.setState({ loading: false }) })
      }
    } else {
      return this.props.addToCart(model, params)
        .then(r => { this.handleCurrentValue() })
        .catch(this.handleAPICatch)
        .finally(r => { this.setState({ loading: false }) })
    }
  }

  deleteItem(cartId) {
    this.$f7.dialog.confirm("آیا از حذف کالا اطمینان دارید؟", "حذف",
      () => this.deleteCartItem(cartId),
      () => {
        this.$f7.dialog.close()
        this.handleAPICatch()
      }
    )
  }

  deleteCartItem(cartId) {
    return this.props.deleteItem(cartId, { store: 2 })
      .then(r => { this.handleCurrentValue() })
      .catch(this.handleAPICatch)
      .finally(r => { this.setState({ loading: false }) })
  }

  handleCurrentValue() {
    const item = this.initialValue;
    const value = item.productCount

    // console.log('handleCurrentValue => cart count:', value, 'currentValue:', this.state.currentValue, 'latestValue:', this.state.latestValue)

    this.setState(prevState => ({
      item: item,
      latestValue: value ? prevState.currentValue : 0,
      currentValue: value,
    }))
  }

  handleAPICatch(err) {
    const msg = (err && err.message) || ''
    const outOfStock = msg.indexOf("insufficient stock quantity") == 0
    if (outOfStock) {
      this.$f7.dialog.alert('تعداد کالای انتخابی از موجودی فروشگاه بیشتر است.', 'خطا')
    } else {
      this.$f7.dialog.alert('خطایی رخ داده، لطفا دوباره تلاش کنید', 'خطا');
    }

    this.setState(prevState => ({
      currentValue: outOfStock && prevState.latestValue > prevState.currentValue ? prevState.currentValue : prevState.latestValue,
      loading: false,
    }), () => {
      if (this.stepperElm.current)
        this.stepperElm.current.setValue(this.state.currentValue)
    })
  }

  handleProductInCart(productId) {
    const { cart } = this.props

    if (!productId)
      return 0

    for (const c of cart) {
      if (c.product.id === productId) {
        return c.count
      }
    }

    return 0
  }

  renderCounter(item) {
    const productCount = this.handleProductInCart(item.productId)

    // console.log('name', item.title, ', productCount:', productCount)

    //TODO change this line in part item.unitType.minimumvalue
    if (item.quantity < item.unitType?.minimumValue) return this.renderNotCounter();

    if (productCount) return this.renderProductCounter(item, productCount)

    return this.renderCounterBTN(item.unitType?.minimumValue);
  }

  renderCounterBTN(minimumValue) {
    const { loading } = this.state;

    return (
      <Button
        className={classes.addToBasketBtn}
        onClick={() => this.changeStepper(minimumValue)}
      >
        {loading
          ? <Preloader size={20} />
          :
          <React.Fragment>
            <Icon icon="mdi-cart-plus" />
            <span>{'افزودن به سبد خرید'}</span>
          </React.Fragment>
        }
      </Button>
    )
  }

  renderProductCounter(item, productCount) {
    const { loading, currentValue } = this.state;
    const { unitType, limitBuyQuantity, quantity } = item;
    let maxValue = (limitBuyQuantity && limitBuyQuantity > 0) ? Math.min(limitBuyQuantity, quantity, unitType?.maximumValue) : Math.min(quantity, unitType?.maximumValue);

    // console.log(`step for ${item.id}`, unitType.step);
    // console.log("maxValue", maxValue);
    // console.log("item in renderproduct counter item", item);

    return (
      // <div className={classes.stepperContainer}>
      <Stepper
        ref={this.stepperElm}
        className={"product-item-stepper"}
        disabled={loading}
        input={false}
        autorepeat={true}
        value={currentValue}
        step={unitType.step}
        // min={unitType.minimumValue ?? null}
        max={maxValue ?? null}
        onStepperChange={this.changeStepper}
      />
      //  <span className={classes.stepperSuffix}>{unitType?.suffix}</span>

      // </div>
    )
  }

  renderNotCounter() {
    return (
      <div style={{ alignSelf: "center" }}>
        {'ناموجود'}
      </div>
    )
  }

  render() {
    const { img, icon, env } = this.props;
    const { item } = this.state;

    return (
      // TODO add expandable prop to card
      <Card className={classes.container}>
        {/* TODO favorite icon */}
        {img && !icon ?
          <img src={img} className={classes.ribbon} />
          :
          <Icon icon={icon} className={classes.ribbon} />
        }
        <CardContent style={{ padding: 0, width: "100%" }}>
          {/* <p>What a nice photo i took yesterday!</p> */}
          {item.currentDiscount && <div className={classes.discountFlag}>٪{Math.floor(item.currentDiscount)} تخفیف</div>}
          <Link
            style={{ width: "100%", flexDirection: "column" }}
            href={`/product/${item.productId}`}
          >
            <div className={classes.parentImageProduct}>
              <LazyLoadImage
                src={item.url}
                alt={item.title}
                effect="opacity"
                threshold={300}
                visibleByDefault={false}
                className={classes.imageProduct} />
            </div>
            <div className={`likes ${classes.titleProduct}`}>{item.title}</div>
          </Link>
          <div className={classes.priceParent}>
            {item.currentDiscount > 0 ? <del className={classes.currentPrice}><Price price={item.currentPrice} hasExtension={false} /></del> : <div>{' '}</div>}
            <div style={{ fontSize: "16px", fontWeight: "400" }}><Price price={item.consumerPrice} /></div>
          </div>
        </CardContent>
        <CardFooter className={`no-border ${classes.cardFooter}`}>
          {this.renderCounter(item)}
        </CardFooter>
      </Card>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    cart: state.Cart.cart
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(autobind(Product))
